module.exports = __webpack_public_path__ + "static/media/08F13B43-8C3A-4246-96F1-D8C944E6C5F4.c2563fab.jpeg";